"use client";

import { useNavigate } from "react-router";
import Icon from "../components/Icon";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Container } from "react-bootstrap";

export default function PrivacyPage() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className="mt-4 mb-5">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                            <h2 className="mb-0">Политика обработки персональных данных</h2>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={handleGoBack}
                                aria-label="Вернуться назад"
                            >
                                <Icon icon={faTimes} />
                            </button>
                        </div>

                        <div className="privacy-policy-content">
                            <h3>1. Общие положения</h3>
                            <p>
                                Настоящая Политика обработки персональных данных (далее — «Политика») определяет порядок обработки персональных данных пользователей сервиса «Артефакты» (далее — «Сервис») и разработана в соответствии с Федеральным законом Российской Федерации №152-ФЗ «О персональных данных».
                            </p>
                            <p>
                                <strong>Оператором персональных данных является:</strong>
                            </p>
                            <ul>
                                <li><strong>ФИО:</strong> Коледина Антонина Владимировна</li>
                                <li><strong>Статус:</strong> Самозанятый (плательщик налога на профессиональный доход)</li>
                                <li><strong>ИНН:</strong> 616 899 406 200</li>
                                <li><strong>E-mail:</strong> staff@insight-systems.ru</li>
                            </ul>
                            <p>
                                Используя Сервис, пользователь выражает согласие с настоящей Политикой.
                            </p>

                            <h3>2. Какие персональные данные обрабатываются</h3>
                            <p>Оператор обрабатывает только следующие персональные данные:</p>
                            <ul>
                                <li>адрес электронной почты (email).</li>
                            </ul>
                            <p>
                                Сервис не собирает паспортные данные, номера телефонов, сведения о банковских картах, биометрические данные и иные специальные категории персональных данных.
                            </p>

                            <h3>3. Цели обработки персональных данных</h3>
                            <p>Адрес электронной почты используется исключительно для следующих целей:</p>
                            <ul>
                                <li>регистрации пользователя;</li>
                                <li>авторизации (входа) в Сервис;</li>
                                <li>восстановления доступа к учетной записи;</li>
                                <li>отправки сервисных уведомлений, связанных с работой Сервиса;</li>
                                <li>информирования пользователя о новых возможностях Сервиса, изменениях условий использования и иных сообщениях, связанных с использованием Сервиса.</li>
                            </ul>
                            <p>
                                Рекламные и маркетинговые рассылки осуществляются только при наличии соответствующего согласия пользователя.
                            </p>

                            <h3>4. Правовые основания обработки</h3>
                            <p>Обработка персональных данных осуществляется на основании:</p>
                            <ul>
                                <li>согласия пользователя;</li>
                                <li>статьи 6 Федерального закона №152-ФЗ «О персональных данных»;</li>
                                <li>необходимости исполнения договора, заключаемого посредством принятия Пользовательского соглашения и Публичной оферты.</li>
                            </ul>

                            <h3>5. Способы обработки</h3>
                            <p>Персональные данные могут обрабатываться с использованием средств автоматизации.</p>
                            <p>Оператор осуществляет:</p>
                            <ul>
                                <li>сбор;</li>
                                <li>запись;</li>
                                <li>систематизацию;</li>
                                <li>хранение;</li>
                                <li>использование;</li>
                                <li>обновление;</li>
                                <li>удаление;</li>
                                <li>уничтожение персональных данных.</li>
                            </ul>

                            <h3>6. Передача персональных данных третьим лицам</h3>
                            <p>Оператор не продает и не передает персональные данные пользователей третьим лицам.</p>
                            <p>Передача персональных данных допускается только:</p>
                            <ul>
                                <li>если это требуется законодательством Российской Федерации;</li>
                                <li>поставщикам технической инфраструктуры, необходимой для работы Сервиса (например, почтовым сервисам, облачному хостингу), исключительно в объеме, необходимом для оказания соответствующих услуг.</li>
                            </ul>
                            <p>Такие лица обязаны соблюдать требования законодательства о персональных данных.</p>

                            <h3>7. Срок хранения персональных данных</h3>
                            <p>Персональные данные хранятся до момента:</p>
                            <ul>
                                <li>удаления учетной записи пользователем;</li>
                                <li>получения требования пользователя об удалении персональных данных;</li>
                                <li>прекращения работы Сервиса;</li>
                                <li>истечения сроков хранения, предусмотренных законодательством Российской Федерации.</li>
                            </ul>
                            <p>
                                После наступления указанных оснований персональные данные удаляются либо обезличиваются в разумный срок.
                            </p>

                            <h3>8. Права пользователя</h3>
                            <p>Пользователь имеет право:</p>
                            <ul>
                                <li>получать сведения об обработке своих персональных данных;</li>
                                <li>требовать уточнения персональных данных;</li>
                                <li>требовать удаления персональных данных;</li>
                                <li>отзывать согласие на обработку персональных данных;</li>
                                <li>обращаться с жалобами в уполномоченные государственные органы.</li>
                            </ul>

                            <h3>9. Защита персональных данных</h3>
                            <p>Оператор принимает необходимые организационные и технические меры для защиты персональных данных от:</p>
                            <ul>
                                <li>неправомерного доступа;</li>
                                <li>изменения;</li>
                                <li>распространения;</li>
                                <li>уничтожения;</li>
                                <li>иных неправомерных действий.</li>
                            </ul>
                            <p>
                                Доступ к персональным данным имеют только лица, которым он необходим для обеспечения функционирования Сервиса.
                            </p>

                            <h3>10. Использование файлов Cookie</h3>
                            <p>
                                Сервис может использовать файлы Cookie и аналогичные технологии для обеспечения корректной работы сайта и повышения удобства его использования.
                            </p>
                            <p>
                                Cookie не используются для идентификации личности пользователя без его участия.
                            </p>

                            <h3>11. Изменение Политики</h3>
                            <p>Оператор вправе изменять настоящую Политику.</p>
                            <p>
                                Актуальная редакция всегда размещается на сайте Сервиса.
                            </p>
                            <p>
                                Продолжение использования Сервиса после публикации новой редакции означает согласие пользователя с изменениями.
                            </p>

                            <h3>12. Контактная информация</h3>
                            <p>По вопросам обработки персональных данных пользователь может обратиться:</p>
                            <ul>
                                <li><strong>Оператор:</strong> Коледина Антонина Владимировна</li>
                                <li><strong>E-mail:</strong> staff@insight-systems.ru</li>
                                <li><strong>Дата последнего обновления:</strong> 25.07.2026</li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
